/* Project Import will be here */
import { getSupportHelplineApi } from "services/common/supportHelpline";
import { getErrorObject, errorToast } from "utilities/utils";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    SUPPORT_HELPLINE_REQUEST: "profile/SUPPORT_HELPLINE_REQUEST",
    SUPPORT_HELPLINE_SUCCESS: "profile/SUPPORT_HELPLINE_SUCCESS",
    SUPPORT_HELPLINE_FAILURE: "profile/SUPPORT_HELPLINE_FAILURE"
};

const initialState = {
    isLoading: false,
    error: null,
    supportHelplineList: []
};

export const supportHelpline = (state = initialState, action) => {
    switch (action.type) {
        case types.SUPPORT_HELPLINE_REQUEST: {
            return { ...state, isLoading: true };
        }
        case types.SUPPORT_HELPLINE_SUCCESS: {
            return { ...state, isLoading: false, supportHelplineList: action.payload.data };
        }
        case types.SUPPORT_HELPLINE_FAILURE: {
            const { error } = action.payload;
            return { ...state, isLoading: false, error };
        }
        default:
            return state;
    }
};

export const getSupportHelpline = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SUPPORT_HELPLINE_REQUEST });
        try {
            const response = await getSupportHelplineApi();
            let data = response.data.Data;

            /*   if Email or Mobile response is null or empty string, will show no data found */
            if (!((data[0].Email !== null && data[0].Email !== "") || (data[0].Mobile !== null && data[0].Mobile !== "")))
                data = [];

            dispatch({ type: types.SUPPORT_HELPLINE_SUCCESS, payload: { data } });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SUPPORT_HELPLINE_FAILURE));
        }
    };
};

const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        /* Extract the error message and error code from the response object */
        const { message, errorCode } = getErrorObject(error);

        dispatch({
            type: type,
            payload: { error: message }
        });

        /* If error code is exist show the error code message or show the error message returned by the API request */
        if (errorCode !== "")
            dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
        else
            errorToast({ content: message });
    }
};